export default __webpack_public_path__ + "4ccad09e8ba919d9d875530de173d41e.png";